import TEXT_RULES, { getBestRule } from './text-rules';
import { removeEl } from './util';
import { MAX_4U_WIDTH } from '../data/constants';


export function preRender(data, options) {
  return data;
}

export function postRender(highchart, options) {
  const R = getRules(options);
  const renderer = highchart.renderer;
  let result = {
    tagline: null,
    source: null,
    note: null,
    date: null,
    x: highchart.spacing[3],
    y: getStartY(highchart, options),
    width: (options.width - highchart.spacing[3] - highchart.spacing[1]) + 'px'
  };
  const { text } = R.headings.source;
  const sourceText = options.id === 'video' && text ?
    text.toUpperCase() : text;
  if (R.tagline) {
    const wsjPrintTagline = isWsjPrintTagline(options.size, 'tagline');
    const taglineAlign = getTaglineAlign(options);
    if (wsjPrintTagline) {
      result.y = options.height;
    }
    result = writeSection(R.headings, options, 'tagline', renderer, R.headings.tagline.text,
      result, taglineAlign);
    if (wsjPrintTagline) {
      result.y = options.height - 9.2;
    }
  }
  if (R.source) {
    result = writeSection(R.headings, options, 'source', renderer, sourceText, result, getSourceAlign(options));
  }
  if (R.note) {
    result = writeSection(R.headings, options, 'note', renderer, R.headings.note.text, result, getNoteAlign(options));
  }
  if (R.date) {
    result = writeSection(R.headings, options, 'date', renderer, R.headings.date.text, result, 'right');
  }

  return result;
}


export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    const invalidSections = {};
    ['tagline', 'source', 'note', 'date'].forEach(section =>
      invalidSections[section] = invalidated.includes(`headings/${section}`))
    // const invalidTagline = invalidated.indexOf('headings/tagline') !== -1;
    // const invalidSource = invalidated.indexOf('headings/source') !== -1;
    // const invalidNote = invalidated.indexOf('headings/note') !== -1;
    if (Object.values(invalidSections).includes(true)) {
      const R = getRules(options);
      const renderer = rendered.outer.renderer;
      let info = rendered.outerInfo.info;
      if (!info) return true;
      info = info.notes;
      info.y = getStartY(rendered.outer, options);

      const taglineAlign = getTaglineAlign(options);
      if (invalidSections.tagline) {
        removeEl(info.tagline);
        if (R.tagline) {
          info = writeSection(R.headings, options, 'tagline', renderer,
            R.headings.tagline.text, info, taglineAlign);
        } else {
          info.tagline = null;
        }
      } else if (info.tagline) {
        info.y = info.tagline.top;
      }
      ['source', 'note', 'date'].forEach(section => invalidSection(section, invalidSections[section]));
      return true;
    }
    return false;
  }
}

function invalidSection(type, isInvalid) {
  if (isInvalid) {
    removeEl(info[type]);
    if (R[type]) {
      info = writeSection(R.headings, options, type, renderer, R.headings[type].text, info);
    } else {
      info[type] = null;
    }
  } else if (info[type]) {
    if (info.y !== info[type].y) {
      let delta = info.y - info[type].y;
      if (info[type].el) {
        let nowY = +info[type].el.element.getAttribute('y');
        info[type].el.element.setAttribute('y', nowY + delta);
      }
      info[type].y += delta;
      info[type].top += delta;
    }
    info.y = info[type].top;
  }
}


function getRules(options) {
  const rule = getBestRule(options.size);
  const { headings } = options;
  const rules = { rule, headings };
  ['tagline', 'source', 'note', 'date'].forEach(section => {
    const { text, enabled } = headings[section];
    rules[section] = text && enabled && rule[section];
  })
  return rules;
}


function writeSection(headings, options, section, renderer, text, result, align = 'left') {
  result[section] = {
    x: result.x,
    y: result.y,
    width: result.width,
    top: result.y,
    el: null
  };
  const obj = writeText(options, renderer, text, result, align, section);
  result[section].el = obj.el;
  result[section].top = obj.top;
  result.y = obj.top;
  if ((section === 'source' || section === 'note') && options.product === 'wsj' && !options.print) {
    if (result.note && !headings.source.text) result.y -= 3;
    if (!headings.note.text && result.source) result.y -= 3;
    if (headings.note.text && headings.source.text && section === 'source') {
      result.y -= 1;
    } 
  }
  if (options.id === 'video') {
    result.y -= 28;
  }
  if (section === 'date') {
    const offset = options.product === 'wsj' ? 9 : 2;
    result.y += offset;
  }
  return result;
}


// Renders a generic block of text (tagline or source) and returns the element
// and its top y.
function writeText(options, renderer, text, result, align = 'left', section = null) {
  const offsetTagline = options.print ? 1 : 0;
  const css = options.styles.get('small', {
    width: result.width
  });
  if (options.product === 'wsj' && !options.print) {
    css.fontSize = '13px';
    css.lineHeight = 17;
  }
  if (options.id === 'video') {
    css.fontSize = '24px';
    css.fontFamily = 'Retina Narrow';
    css.color = '#CCC';
    css.fontWeight = 500;
  }
  if (options.product === 'mansionglobal') {
    css.color = options.styles.notes.color;
  }
  if (__WSJ__) {
    if (isWsjPrintTagline(options.size, section)) {
      css.fontFamily = "'DJ5EscrowCond Semibold'";
      css.fontSize = 6.6;
    } else if (options.size === 'print-wsj') {
      css.fontFamily = "'DJ5RetinaAgReg Medium'";
    }
    if (options.product === 'wsj' && (section === 'source' || section === 'note')) {
      css.color = '#666';
    }
  }
  if (options.id === 'print-barrons') {
    css.fontSize = 6;
  }
  if (section === 'date' && options.product === 'wsj') {
    css.fontFamily = 'Retina Narrow';
  }
  const el = renderer.text(text)
    .css(css)
    .attr({
      x: align === 'left' ? result.x : parseFloat(result.width),
      y: result.y - offsetTagline,
      align
    })
    .add();
  const lines = el.element.querySelectorAll('tspan').length;
  const lineHeight = parseFloat(css.lineHeight);
  const height = lines * lineHeight;
  let yPx = result.y;
  if (lines > 1) {
    yPx = +el.element.getAttribute('y');
    yPx -= (lines - 1) * lineHeight;
    el.element.setAttribute('y', yPx);
  }
  return {
    el,
    y: yPx,
    top: yPx - lineHeight
  };
}

function getSourceAlign(options) {
  return options.product === 'marketwatch' || options.id === 'print-barrons' ? 'right' : 'left';
}

function getNoteAlign(options) {
  return options.id === 'print-barrons' ? 'right' : 'left';
}

function getTaglineAlign(options) {
  if (__WSJ__) {
    if (options.size === 'print-wsj') {
      return (options.sizes['print-wsj'].columns >= 2) ? 'right' : 'left';
    } else {
      return (options.width > MAX_4U_WIDTH) ? 'right' : 'left';
    }
  }
  if (!__WSJ__) {
    return (options.width > MAX_4U_WIDTH) ? 'right' : 'left';
  }
}

function getStartY(highchart, options) {
  return options.height - highchart.spacing[2] - yOffset(options);
}

// Lifts text just enough so that bottom line shows tails.
function yOffset(options) {
  return Math.round((parseFloat(options.styles.lineHeight.small) -
    parseFloat(options.styles.size.small)) * 0.5);
}

function isWsjPrintTagline(size, section) {
  if (__WSJ__) {
    return size === 'print-wsj' && section === 'tagline';
  }
  return false;
}


// WEBPACK FOOTER //
// ./src/chart/outer/notes.js